import type { SyntheticEvent } from "react";
import React from "react";
import { Trans, useTranslation } from "@litres-libs/i18n";
import { SpriteIcon } from "@litres-libs/sprite-icons";
import { useAppSelector } from "@litres-core/store";
import { SmartLink } from "@litres-modules/smart-link";
import styles from "./SuccessPanel.module.scss";
interface ISuccessPanel {
  onClose?: (e: SyntheticEvent) => void;
  isVisible?: boolean;
}

export const SuccessPanel = ({ onClose, isVisible = true }: ISuccessPanel) => {
  const { t } = useTranslation();
  const isPDA = useAppSelector(state => state.browser.pda);
  const link = isPDA
    ? "/pages/my_settings/"
    : "/pages/personal_cabinet_about_me/";
  if (!isVisible) {
    return null;
  }
  return (
    <div className={styles.successPanel} data-testid="safemode__success-panel">
      <div className={styles.successPanel__icon}>
        <SpriteIcon name="successLogo" size={20} />
      </div>
      <div className={styles.successPanel__content}>
        <span>
          <Trans
            i18nKey={
              'Настройки сохранены. Вы можете изменить их в <a href="{link}" target="_blank">профиле</a>'
            }
            defaults={
              'Настройки сохранены. Вы можете изменить их в <a href="{link}" target="_blank">профиле</a>'
            }
            values={{ link }}
            components={{ a: <SmartLink /> }}
          />
        </span>
      </div>
      <button
        type="button"
        className={styles["successPanel__close-button"]}
        onClick={onClose}
        data-testid="safemode__close-button"
        aria-label={t("Закрыть")}
      >
        <SpriteIcon name="close" size={16} />
      </button>
    </div>
  );
};
